var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{attrs:{"outlined":""}},[_c('v-card-text',[_c('FilterBar',{attrs:{"value":_vm.localFilters},on:{"input":_vm.handleInputFilter}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }